<div class="item-container">
    <div class="item-header">
      <h5 class="text-center">{{"Assign Survey" | translate}}</h5>
      <div class="edit-icons" (click)="onCancel()">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="item-content  mt-4 px-2">
        <form action="" [formGroup]="assignForm">
        <div class="overflow-cont">
          <mat-checkbox name="agree" class="mt-2 c-s ms-2" formControlName="all_user">
            <div class="text-wrap">Assign to all employee</div>
        </mat-checkbox>
        <div>
        </div>
         <div *ngIf="assignForm.value.all_user!=true">   
            <label for="" class="me-3 mt-2 pt-1 mb-0">Select User Type</label>     
            <div class="d-flex flex-wrap">
              <div class="e-b mt-2" [ngClass]="{'sel':userType=='department'}"(click)="onUserType('department')">Department</div>
              <div class="e-b mt-2" [ngClass]="{'sel':userType=='manager'}" (click)="onUserType('manager')">Manager</div>
              <div class="e-b mt-2" [ngClass]="{'sel':userType=='employee'}" (click)="onUserType('employee')">Employee</div>             
            </div>
            <label for="" class="me-3 mt-3 pt-lg-2">Select User </label>     
            <div class="list">
              <ng-multiselect-dropdown formControlName="d_i" *ngIf="userType=='department'" [settings]="dropdownSettings" [data]="departmentArr"  >
              </ng-multiselect-dropdown>
              <ng-multiselect-dropdown formControlName="em_i" *ngIf="userType=='employee'" [settings]="dropdownSettingsEmp" [data]="empArr"  >
              </ng-multiselect-dropdown>
              <ng-multiselect-dropdown formControlName="ma_i" *ngIf="userType=='manager'" [settings]="dropdownSettingsMan" [data]="managerArr"  >
              </ng-multiselect-dropdown>
            </div>
           
         </div>
        <div>
            <mat-error *ngIf="isErr">  {{"This is required"|translate}} </mat-error>
        </div>
        </div>
   
   
        </form>
    </div>
    <div class="row">
      <div class="col-md-6 m-auto mt-xl-2">
        <button mat-raised-button   color="primary"  class="auth-form-btn mt-3 mt-lg-4"  type="submit" (click)="onSubmit()"
        >{{ "Save" | translate }}</button>
      </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>